/*
 *
 * GenericShopList
 *
 * @version 1.0.0
 * @author Marco Alessandroni
 * @since 30-Jun-2025
*/

import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux'
import GenericShopList from './GenericShopList'
import { doGetListOfShopsGt } from 'Store/actions/shopPicker'
import { doHidePopup } from 'Store/actions/popup'
import { doShowToast } from 'Store/actions/toast'
import { nullSafe } from 'Utility/globalMethods'

const mapDispatchToProps = dispatch => ({
  doClosePopup: (type) => dispatch(doHidePopup(type)),
  doGetListOfShopsGt: (pageNumber, pageSize) => dispatch(doGetListOfShopsGt(pageNumber, pageSize)),
  doShowToast: (key, moreInfo, id) => dispatch(doShowToast(key, moreInfo, id))
})

const mapStateToProps = (state) => ({
  pointOfSalesData: nullSafe(() => state.shopPicker.gtShopList, []),
  gtShopListLoading: nullSafe(() => state.shopPicker.gtShopListLoading, false),
  gtShopListPagination: nullSafe(() => state.shopPicker.gtShopListPagination, {
    total: 0,
    pageNumber: 0,
    pageSize: 15
  }),
  // Access dispute data directly from Redux state
  disputeShops: nullSafe(() => state.Dispute?.creationDispute?.shops, [])
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(GenericShopList)
